export default "//cdn.scentbird.com/assets/frontbird-site/images/bird@2x_5f0c44.png";